/**
 * Take a token and show the account setup/verification view
 *
 * It's expected that this controller is only ever hit from the router
 * and therefore the URL in the browser will already be set and we don't have
 * to call set_location to set the location explicitly.
 */
import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import SignupAccount from '@/models/v5/signup_account';
import VerifyView from '@/views/login_verify';
import VerifyErrorTemplate from '@/../templates/login-verify-error.hbs';

var globalCh = Radio.channel('global');

export default function verify(token, type) {
    var options = globalCh.request('app_options');
    if (options.theme && options.theme.app_title) {
        document.title = options.theme.app_title + " Verify Account";
    } else {
        document.title = "Electric Imp Verify Account";
    }
    var account = new SignupAccount({
        token: token
    });
    var app_layout = globalCh.request('ensure_login_layout');

    // Show the verification form. We should call this only after we first
    // call the /v5/verify endpoint and handle an error which will tell
    // us all the legal country names we can use in the final verification
    // step
    function show_verification_form(options) {
        var view = new VerifyView({
            validToken: true,
            suggested_country: options.suggested_country,
            valid_countries: options.valid_countries,
            password_requirements: options.password_requirements,
            model: account
        });
        app_layout.showChildView('content', view);
    }
    function show_error(e) {
        const VerifyErrorView = Marionette.View.extend({
            ui: {
                signin : '.signin'
            },
            events: {
                'click @ui.signin' : 'signin'
            },
            template: Handlebars.compile(VerifyErrorTemplate),
            templateContext: function(){
                const data = this.options.data;
                var message = '';
                var action = '';
                var action_title = '';
                switch (data.detail) {
                    case 'The x-electricimp-token header is expired.':
                        message = 'That token has already expired. Please sign up again with your email address.';
                        action = 'signin';
                        action_title = 'Sign Up';
                        break;
                    case 'The x-electricimp-token header has already been claimed.':
                        message = 'That token has already been claimed. Please sign in with your email address.';
                        action = 'signin';
                        action_title = 'Sign In';
                        break;
                    case 'Invalid x-electricimp-token header.':
                        message = 'The token you provided is invalid. Please sign up again with your email address.';
                        action = 'signin';
                        action_title = 'Sign Up';
                        break;
                    default:
                        message = data.detail +' Please try signing up again with your email address.';
                        action = 'signin';
                        action_title = 'Sign Up';
                }

                return {
                    message: message,
                    action: action,
                    action_title: action_title
                };
            },
            signin: function(){
                globalCh.request('login');
            }
        });
        const error_view = new VerifyErrorView({ data: e });
        app_layout.showChildView('content', error_view);
    }

    account.get_verification_params()
        .then(show_verification_form, show_error);
}

